import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { IMusicProductPhysicalLight } from './types/query';

export const useGetMusicProductPhysicalLightList = () => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IMusicProductPhysicalLight[], DefaultError>({
    queryKey: ['mpp-light-list'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `MusicProductPhysical/LightList`,
      });

      return responseHandler(response, {
        groupName: `useGetMusicProductPhysicalLightList`,
      });
    },
  });
};
